<div
  *ngIf="offer"
  class="col-3 d-flex gap-2 align-items-center"
>
  <base-avatar
    [image]="offer.data.anonymous ? '' : offer.data.profile.avatar || ''"
    [size]="avatarSize.medium"
    (click)="openOfferInfoModal(offer.data, false, $event)"
  ></base-avatar>
  <div
    class="d-flex flex-column"
    baseTruncate
  >
    <div (click)="openOfferInfoModal(offer.data, false, $event)">
      <div
        baseTruncate
        *ngIf="offer.data.anonymous && offer.data.status !== offerStatuses.confirmed"
      >
        <span class="m-0 fw-bold listview-highlight-text">
          {{ offer.data.profile.firstName | baseAnonymizeFullName: offer.data.profile.lastName }}
        </span>
        <br />
        <span class="m-0 fw-bold text-dark-gray fa-0-75x">
          {{ 'inquiry.anonymizedOffer' | translate }}
        </span>
      </div>
      <ng-container *ngIf="!offer.data.anonymous || offer.data.status === offerStatuses.confirmed">
        <p
          baseTruncate
          class="m-0 fw-bold listview-highlight-text"
        >
          {{ offer.data.profile.firstName }} {{ offer.data.profile.lastName }}
        </p>
      </ng-container>
    </div>
    <base-candidate-shifts-availability
      class="mt-2"
      [candidateAvailability]="offer.data.profile.candidateAvailability"
    ></base-candidate-shifts-availability>
    <base-candidate-weekdays-availability
      [candidateAvailability]="offer.data.profile.candidateAvailability"
    ></base-candidate-weekdays-availability>
  </div>
</div>
<div
  *ngIf="offer"
  class="col-3 d-flex align-items-center gap-2"
>
  <i
    class="fa-solid"
    [ngClass]="{
      'fa-circle-a a': offer.data.pspBranch.deliveryType === 'a',
      'fa-circle-b b': offer.data.pspBranch.deliveryType === 'b',
      'fa-circle-c c': offer.data.pspBranch.deliveryType === 'c',
      'fa-circle-xmark': !offer.data.pspBranch.deliveryType
    }"
    [ngbTooltip]="
      ('administration.timeToWait.timeToWaitCategory' | translate) +
      (offer.data.pspBranch.deliveryType === 'a' ? ' A' : offer.data.pspBranch.deliveryType === 'b' ? ' B' : ' C')
    "
  ></i>
  <div baseTruncate>
    <span>{{ offer.data.psp.name }}</span>
    <br />
    <span>{{ offer.data.pspBranch.name }}</span>
  </div>
</div>
<div class="col-2">
  <div
    baseTruncate
    class="main-qualification-text"
  >
    {{ offer?.data?.mainQualification?.name | baseIsEmpty }}
  </div>
  <base-additional-list
    [list]="offer?.data?.profile?.qualifications || []"
    firstItemClass="alternative-qualification-text"
  ></base-additional-list>
</div>
<div
  baseTruncate
  class="col-1"
>
  {{ offer?.data?.hourlyRate | baseFormatDecimal | baseIsEmpty }} €
</div>
<div
  baseTruncate
  class="col-1"
>
  <ng-container *ngIf="offer">
    <ng-container *ngIf="offer.data.positions.length as count">
      {{ offer.data.positions[0].date | baseFormatDate }}
      <br />
      <ng-container *ngIf="count > 1">
        {{ offer.data.positions[count - 1].date | baseFormatDate }}
      </ng-container>
    </ng-container>
  </ng-container>
</div>
<div
  *ngIf="offer"
  class="col-2"
>
  <div class="d-flex flex-nowrap gap-2 align-items-center justify-content-between">
    <div class="d-flex flex-wrap gap-2 align-items-center">
      <i
        class="fa-solid pointer"
        (click)="openRequirementsModal($event, offer.data.profile)"
        [ngbTooltip]="
          isRequirementsFulfilled
            ? ('inquiry.allRequirementsFulfilled' | translate)
            : ('inquiry.notAllRequirementsFulfilled' | translate)
        "
        [ngClass]="isRequirementsFulfilled ? 'fa-check text-primary' : 'fa-xmark text-light-gray'"
      ></i>
      <i
        class="fa-solid fa-calendar text-primary"
        [ngbTooltip]="'inquiry.offeredDays' | translate"
        (click)="openPositionsDatePickerModal($event, offer.data)"
      ></i>
      <i
        (click)="openNoteFromProviderModal($event, offer.data)"
        class="mt-1 mb-0 pointer"
        [ngClass]="offer.data.note ? 'fa-solid fa-message text-primary' : 'fa-regular fa-message-slash text-light-gray'"
        [ngbTooltip]="
          offer.data.note ? ('tooltip.remarkFromProvider' | translate) : ('tooltip.noRemarksFromProvider' | translate)
        "
      ></i>
      <i
        class="fa-solid mt-1 mb-0 fa-building"
        [ngClass]="offer.data.profile.experience ? 'text-primary' : 'text-light-gray'"
        [ngbTooltip]="
          offer.data.profile.experience
            ? ('tooltip.experienceInCompany' | translate)
            : ('tooltip.noExperienceInCompany' | translate)
        "
      ></i>
      <span class="star">
        <i
          class="fa-fw fa-star"
          [ngClass]="offer.data.profile.ratingCount ? 'fas text-warning' : 'far text-light-gray'"
          [ngbTooltip]="starTooltip"
        ></i>
        <ng-template #starTooltip>
          <ng-container *ngIf="offer as currentOffer">
            <base-rating
              *ngIf="(currentOffer.data.profile.ratingCount ?? 0) > 0"
              [hideCount]="true"
              [currentRate]="currentOffer.data.profile.averageRating"
              starIconClasses="fs-7"
            ></base-rating>
            <div *ngIf="!currentOffer.data.profile.ratingCount">
              {{ 'inquiry.noRatingMessage' | translate }}
            </div>
          </ng-container>
        </ng-template>
      </span>
      <img
        [src]="
          offer.data.industrySurcharges
            ? 'assets-global/images/industry-surcharges-growth.svg'
            : 'assets-global/images/industry-surcharges-disabled.svg'
        "
        [ngClass]="offer.data.industrySurcharges ? 'pointer' : 'no-pointer'"
        (click)="openIndustrySurchargeModal($event, offer.data.industrySurcharges)"
        [ngbTooltip]="
          offer.data.industrySurcharges
            ? ('tooltip.industrySurcharges' | translate)
            : ('tooltip.noIndustrySurcharges' | translate)
        "
        alt="Industry Surcharges List"
      />
      <base-izs-rating
        [color]="offer.data.pspBranch.izsStatus"
        [isSmallLogo]="true"
        (click)="openIzsInfoModal($event, offer.data.pspBranch)"
      ></base-izs-rating>
    </div>

    <base-customer-unlimited-offer-actions
      [offer]="offer"
      [offerAction]="offerAction"
      [locationWorkCouncilSettings]="locationWorkCouncilSettings"
      (openOfferInfoModal)="openOfferInfoModal($event, true)"
    ></base-customer-unlimited-offer-actions>
  </div>
</div>

<ng-template #offerInfoPopup>
  <base-customer-offer-info-modal
    [offer]="offer?.data"
    [inquiry]="inquiry"
    [assignment]="assignmentInfo"
    [assignmentContractSigningStatus]="validContract?.signingStatus || signingStatus.unsigned"
    [inquiryRequirementCategories]="inquiry.requirements || []"
    [modalRef]="infoModalRef"
    [openOperationInfo]="toOperationTab"
    [isAssignmentsAdmin]="hasAdminAssignmentsPermission"
    (acceptOrRejectOffer)="acceptOrRejectOfferFromInfoModal($event)"
  ></base-customer-offer-info-modal>
</ng-template>

<ng-template #datePickerModal>
  <base-date-picker-modal [currentOffer]="offer?.data"></base-date-picker-modal>
</ng-template>

<ng-template #industrySurchargesModal>
  <base-industry-surcharges
    [surcharges]="offer?.data?.industrySurcharges"
    [showCategoryAndMethod]="true"
  ></base-industry-surcharges>
</ng-template>

<ng-template #requirementsPopup>
  <base-inquiry-requirements-modal
    [inquiryRequirements]="baseInquiryService.ungroupRequirements(inquiry.requirements)"
    [candidateRequirements]="offerProfileRequirements"
  ></base-inquiry-requirements-modal>
</ng-template>
